import { ChatSessionService } from "../../../services/chat-session.service";
import { querySelectorAllShadows } from "../../../utility";

export function TriggerLoginHandler(_: never, webchat: any, chatSessionService: ChatSessionService) {
    if (pnlUserMenuExists()) {
        console.debug('pnl-user-menu found. Triggering login');
        triggerLogin(chatSessionService);
    }
    else {
        console.debug('No pnl-user-menu found.');
        webchat.sendMessage('', { success: false });
    }
}

function triggerLogin(chatSessionService: ChatSessionService) {
    chatSessionService.pushLoginTriggered();
    window.dispatchEvent(new CustomEvent('postnl:identity:login'));
}

function pnlUserMenuExists() {
    return querySelectorAllShadows('pnl-user-menu').length > 0;
}
